export default __webpack_public_path__ + "static/media/Strangler's Veil of the Grim Cabal.99cae0ef.jpg";